import { render, staticRenderFns } from "./VLinkTextGuides.vue?vue&type=template&id=3025991a&scoped=true&"
import script from "./VLinkTextGuides.vue?vue&type=script&lang=js&"
export * from "./VLinkTextGuides.vue?vue&type=script&lang=js&"
import style0 from "./VLinkTextGuides.vue?vue&type=style&index=0&id=3025991a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3025991a",
  null
  
)

export default component.exports